module.exports = __webpack_public_path__ + "img/dscvry_logo-white.9057dce4.svg";